<template>
  <div class="text-black mb-3">
    <div v-if="!showDetail">
      <div class="mb-0 text-blue-800 text-base flex justify-end">
        <!-- <div class="text-black fs-14 mr-3 cursor-pointer fw-600" @click="showModal(true)">
          <svg
            class="mr-1"
            width="16"
            height="16"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.039 5.13579L8.1 3.06528V11.6984C8.1 11.9372 8.19482 12.1662 8.3636 12.335C8.53239 12.5038 8.76131 12.5987 9 12.5987C9.23869 12.5987 9.46761 12.5038 9.6364 12.335C9.80518 12.1662 9.9 11.9372 9.9 11.6984V3.06528L11.961 5.13579C12.0447 5.22017 12.1442 5.28714 12.2539 5.33284C12.3636 5.37855 12.4812 5.40208 12.6 5.40208C12.7188 5.40208 12.8364 5.37855 12.9461 5.33284C13.0558 5.28714 13.1553 5.22017 13.239 5.13579C13.3234 5.05211 13.3903 4.95254 13.436 4.84284C13.4817 4.73314 13.5052 4.61547 13.5052 4.49663C13.5052 4.37779 13.4817 4.26013 13.436 4.15043C13.3903 4.04073 13.3234 3.94116 13.239 3.85747L9.639 0.256576C9.55341 0.174619 9.45248 0.110375 9.342 0.067529C9.12288 -0.0225097 8.87712 -0.0225097 8.658 0.067529C8.54752 0.110375 8.44659 0.174619 8.361 0.256576L4.761 3.85747C4.67709 3.94141 4.61052 4.04106 4.56511 4.15072C4.51969 4.26039 4.49632 4.37793 4.49632 4.49663C4.49632 4.61534 4.51969 4.73288 4.56511 4.84254C4.61052 4.95221 4.67709 5.05186 4.761 5.13579C4.84491 5.21973 4.94454 5.28631 5.05418 5.33173C5.16382 5.37716 5.28133 5.40054 5.4 5.40054C5.51867 5.40054 5.63618 5.37716 5.74582 5.33173C5.85546 5.28631 5.95509 5.21973 6.039 5.13579ZM17.1 8.99776C16.8613 8.99776 16.6324 9.0926 16.4636 9.26142C16.2948 9.43025 16.2 9.65922 16.2 9.89798V15.2993C16.2 15.5381 16.1052 15.7671 15.9364 15.9359C15.7676 16.1047 15.5387 16.1996 15.3 16.1996H2.7C2.4613 16.1996 2.23239 16.1047 2.0636 15.9359C1.89482 15.7671 1.8 15.5381 1.8 15.2993V9.89798C1.8 9.65922 1.70518 9.43025 1.5364 9.26142C1.36761 9.0926 1.13869 8.99776 0.9 8.99776C0.661305 8.99776 0.432387 9.0926 0.263604 9.26142C0.0948211 9.43025 0 9.65922 0 9.89798V15.2993C0 16.0156 0.284464 16.7025 0.790812 17.209C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.209C17.7155 16.7025 18 16.0156 18 15.2993V9.89798C18 9.65922 17.9052 9.43025 17.7364 9.26142C17.5676 9.0926 17.3387 8.99776 17.1 8.99776Z"
              fill="#03267A"
            />
          </svg>
          Upload Phiếu
        </div>-->
        <div class="flex items-center">
          <span @click="ModalCreate" class="fs-14 fw-700 text-grey-900 cursor-pointer">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mr-2"
            >
              <path
                d="M8.99984 0.666748C7.35166 0.666748 5.7405 1.15549 4.37009 2.07117C2.99968 2.98685 1.93158 4.28834 1.30084 5.81105C0.670115 7.33377 0.505087 9.00933 0.82663 10.6258C1.14817 12.2423 1.94185 13.7272 3.10728 14.8926C4.27272 16.0581 5.75758 16.8517 7.37409 17.1733C8.9906 17.4948 10.6662 17.3298 12.1889 16.6991C13.7116 16.0683 15.0131 15.0002 15.9288 13.6298C16.8444 12.2594 17.3332 10.6483 17.3332 9.00008C17.3332 7.90573 17.1176 6.8221 16.6988 5.81105C16.28 4.80001 15.6662 3.88135 14.8924 3.10752C14.1186 2.3337 13.1999 1.71987 12.1889 1.30109C11.1778 0.882296 10.0942 0.666748 8.99984 0.666748ZM8.99984 15.6667C7.6813 15.6667 6.39237 15.2758 5.29604 14.5432C4.19971 13.8107 3.34523 12.7695 2.84064 11.5513C2.33606 10.3331 2.20404 8.99269 2.46127 7.69948C2.71851 6.40627 3.35345 5.21839 4.2858 4.28604C5.21815 3.35369 6.40603 2.71875 7.69924 2.46151C8.99245 2.20428 10.3329 2.3363 11.5511 2.84088C12.7692 3.34547 13.8104 4.19995 14.543 5.29628C15.2755 6.39261 15.6665 7.68154 15.6665 9.00008C15.6665 10.7682 14.9641 12.4639 13.7139 13.7141C12.4636 14.9644 10.768 15.6667 8.99984 15.6667ZM12.3332 8.16675H9.83317V5.66675C9.83317 5.44573 9.74538 5.23377 9.5891 5.07749C9.43282 4.92121 9.22085 4.83342 8.99984 4.83342C8.77883 4.83342 8.56687 4.92121 8.41059 5.07749C8.25431 5.23377 8.16651 5.44573 8.16651 5.66675V8.16675H5.66651C5.44549 8.16675 5.23353 8.25455 5.07725 8.41083C4.92097 8.56711 4.83317 8.77907 4.83317 9.00008C4.83317 9.2211 4.92097 9.43306 5.07725 9.58934C5.23353 9.74562 5.44549 9.83342 5.66651 9.83342H8.16651V12.3334C8.16651 12.5544 8.25431 12.7664 8.41059 12.9227C8.56687 13.079 8.77883 13.1667 8.99984 13.1667C9.22085 13.1667 9.43282 13.079 9.5891 12.9227C9.74538 12.7664 9.83317 12.5544 9.83317 12.3334V9.83342H12.3332C12.5542 9.83342 12.7662 9.74562 12.9224 9.58934C13.0787 9.43306 13.1665 9.2211 13.1665 9.00008C13.1665 8.77907 13.0787 8.56711 12.9224 8.41083C12.7662 8.25455 12.5542 8.16675 12.3332 8.16675Z"
                fill="#03267A"
              />
            </svg>
            Thêm Phiếu mới
          </span>
        </div>
      </div>

      <div v-loading="loading && !update.show" class="handleLoading">
        <el-table
          :data="reExaminations"
          :default-sort="{ prop: 'date', order: 'descending' }"
          style="width: 100%"
          row-class-name="text-black text-sm"
          header-cell-class-name="text-black text-base font-semibold"
          class="cursor-pointer"
          @row-click="goToViewDetail"
        >
          <el-table-column :formatter="getDate" label="Ngày khám bệnh"></el-table-column>
          <el-table-column
            :formatter="
              (row) => {
                return row.Doctor && row.Doctor.User.name;
              }
            "
            label="Bác sĩ Khám"
            class-name="text-center"
          ></el-table-column>
          <el-table-column :formatter="getDateTime" label="Ngày hẹn khám"></el-table-column>
        </el-table>
        <div class="flex justify-content-end mt-3">
          <el-pagination
            v-if="reExaminations"
            background
            layout="prev, pager, next"
            :total="reExaminationsPaging.total"
            :page-size="parseInt(reExaminationsPaging.per_page)"
            @current-change="handleCurrentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div v-else>
      <Detail />
    </div>
    <modalCreateForm
      ref="modalCreateForm"
      :type="'create'"
      @onCreate="createReExamination($event)"
    />
    <div
      class="modal fade"
      id="modalPDF"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalPDFLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sx" role="document">
        <div class="modal-content" v-loading="loading">
          <div class="d-flex justify-content-between p-3">
            <div class="fs-24 fw-700 txt-grey-900 text-center w-100">
              <span>Upload Phiếu</span>
            </div>
            <!-- <button
            type="button"
            class="close bg-white border-0"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              class="fs-30 fw-700"
            >&times;</span>
            </button>-->
          </div>
          <div class="modal-body">
            <div class="mb-3 row">
              <div class="col-md-4">
                <label class="mb-1 fs-16 txt-grey-900 fw-700 mt-2 required">Ngày tạo:</label>
              </div>
              <div class="col-md-8">
                <input v-model="form.date" type="date" class="form-control fw-700 txt-grey-900" />
              </div>
            </div>
            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Bác sĩ PT:</p>
              </div>
              <div class="col-md-8">
                <el-select
                  v-model="form.surgical_main"
                  filterable
                  @change="getDoctor(null)"
                  remote
                  :reserve-keyword="false"
                  allow-create
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.user_id"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Bác sĩ gây mê:</p>
              </div>
              <div class="col-md-8">
                <el-select
                  @change="getDoctor(null)"
                  v-model="form.anaesthetic_main"
                  filterable
                  allow-create
                  remote
                  reserve-keyword
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.user_id"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-9">
                <p class="mt-2 fs-14">{{ file ? file.name : "Chưa chọn file" }}</p>
              </div>
              <div class="col-md-3">
                <div
                  v-if="file"
                  @click="onShowPickFile"
                  class="mt-3 ml-4 fs-16 text-blue-900 underline cursor-pointer hover:text-blue-500"
                >Thay đổi</div>
                <button
                  v-if="!file"
                  @click="onShowPickFile"
                  type="button"
                  class="btn bg-pri text-white mt-2"
                >
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.78945 6.42495L7.31161 4.50829V12.5C7.31161 12.721 7.38164 12.9329 7.50629 13.0892C7.63095 13.2455 7.80002 13.3333 7.9763 13.3333C8.15259 13.3333 8.32166 13.2455 8.44632 13.0892C8.57097 12.9329 8.641 12.721 8.641 12.5V4.50829L10.1632 6.42495C10.2249 6.50306 10.2985 6.56506 10.3795 6.60736C10.4605 6.64967 10.5473 6.67145 10.6351 6.67145C10.7228 6.67145 10.8097 6.64967 10.8907 6.60736C10.9717 6.56506 11.0452 6.50306 11.107 6.42495C11.1693 6.34749 11.2188 6.25532 11.2525 6.15377C11.2863 6.05222 11.3036 5.9433 11.3036 5.83329C11.3036 5.72328 11.2863 5.61436 11.2525 5.51281C11.2188 5.41126 11.1693 5.31909 11.107 5.24162L8.44824 1.90829C8.38502 1.83242 8.31048 1.77295 8.22889 1.73329C8.06706 1.64994 7.88555 1.64994 7.72372 1.73329C7.64213 1.77295 7.56759 1.83242 7.50437 1.90829L4.84559 5.24162C4.78361 5.31932 4.73445 5.41156 4.70091 5.51308C4.66737 5.6146 4.65011 5.72341 4.65011 5.83329C4.65011 5.94317 4.66737 6.05198 4.70091 6.1535C4.73445 6.25501 4.78361 6.34726 4.84559 6.42495C4.90756 6.50265 4.98114 6.56429 5.06211 6.60634C5.14309 6.64839 5.22987 6.67003 5.31752 6.67003C5.40517 6.67003 5.49196 6.64839 5.57293 6.60634C5.6539 6.56429 5.72748 6.50265 5.78945 6.42495ZM13.9586 11.6666C13.7823 11.6666 13.6132 11.7544 13.4886 11.9107C13.3639 12.067 13.2939 12.2789 13.2939 12.5V15.8333C13.2939 16.0543 13.2238 16.2663 13.0992 16.4225C12.9745 16.5788 12.8055 16.6666 12.6292 16.6666H3.32343C3.14714 16.6666 2.97808 16.5788 2.85342 16.4225C2.72877 16.2663 2.65874 16.0543 2.65874 15.8333V12.5C2.65874 12.2789 2.58871 12.067 2.46405 11.9107C2.3394 11.7544 2.17033 11.6666 1.99404 11.6666C1.81775 11.6666 1.64869 11.7544 1.52403 11.9107C1.39938 12.067 1.32935 12.2789 1.32935 12.5V15.8333C1.32935 16.4963 1.53944 17.1322 1.9134 17.6011C2.28736 18.0699 2.79457 18.3333 3.32343 18.3333H12.6292C13.158 18.3333 13.6652 18.0699 14.0392 17.6011C14.4132 17.1322 14.6233 16.4963 14.6233 15.8333V12.5C14.6233 12.2789 14.5532 12.067 14.4286 11.9107C14.3039 11.7544 14.1349 11.6666 13.9586 11.6666Z"
                      fill="white"
                    />
                  </svg>
                  Chọn file
                </button>
                <input
                  id="file-upload"
                  class="d-none"
                  name="file-upload"
                  type="file"
                  @change="onSelectFile"
                  :key="fileInputKey"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              id="closeModal"
              type="button"
              class="btn bg-white text-blue-900"
              data-dismiss="modal"
              @click="closeModal"
            >Hủy</button>
            <button
              :disabled="loading"
              @click="onSubmit"
              type="button"
              class="btn bg-pri text-white"
            >Lưu</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="ModalChiTietPPTTT"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalChiTietPPTTTLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="d-flex justify-content-between p-3">
            <div
              class="fs-24 fw-700 txt-grey-900 text-center w-100 uppercase"
            >{{ update.show ? "Chỉnh sửa phiếu" : "Chi tiết phiếu" }}</div>
            <div class="flex flex-end items-center">
              <svg
                width="18"
                height="18"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2 cursor-pointer"
                @click="onUpdate"
                v-if="
                  viewingFileDetail &&
                  viewingFileDetail.created_by &&
                  viewingFileDetail.created_by == $user.id
                "
              >
                <path
                  d="M21.8749 12.4999C21.5987 12.4999 21.3337 12.6096 21.1383 12.805C20.943 13.0003 20.8333 13.2653 20.8333 13.5415V19.7915C20.8333 20.0678 20.7235 20.3327 20.5282 20.5281C20.3328 20.7234 20.0679 20.8332 19.7916 20.8332H5.20825C4.93198 20.8332 4.66703 20.7234 4.47168 20.5281C4.27633 20.3327 4.16659 20.0678 4.16659 19.7915V5.20819C4.16659 4.93192 4.27633 4.66697 4.47168 4.47162C4.66703 4.27627 4.93198 4.16652 5.20825 4.16652H11.4583C11.7345 4.16652 11.9995 4.05678 12.1948 3.86142C12.3902 3.66607 12.4999 3.40112 12.4999 3.12486C12.4999 2.84859 12.3902 2.58364 12.1948 2.38829C11.9995 2.19294 11.7345 2.08319 11.4583 2.08319H5.20825C4.37945 2.08319 3.58459 2.41243 2.99854 2.99848C2.41249 3.58453 2.08325 4.37939 2.08325 5.20819V19.7915C2.08325 20.6203 2.41249 21.4152 2.99854 22.0012C3.58459 22.5873 4.37945 22.9165 5.20825 22.9165H19.7916C20.6204 22.9165 21.4152 22.5873 22.0013 22.0012C22.5873 21.4152 22.9166 20.6203 22.9166 19.7915V13.5415C22.9166 13.2653 22.8068 13.0003 22.6115 12.805C22.4161 12.6096 22.1512 12.4999 21.8749 12.4999ZM6.24992 13.2915V17.7082C6.24992 17.9845 6.35967 18.2494 6.55502 18.4448C6.75037 18.6401 7.01532 18.7499 7.29159 18.7499H11.7083C11.8453 18.7506 11.9812 18.7244 12.1082 18.6725C12.2351 18.6207 12.3505 18.5443 12.4478 18.4478L19.6562 11.229L22.6145 8.33319C22.7121 8.23635 22.7896 8.12114 22.8425 7.99421C22.8954 7.86727 22.9226 7.73112 22.9226 7.59361C22.9226 7.45609 22.8954 7.31994 22.8425 7.193C22.7896 7.06607 22.7121 6.95086 22.6145 6.85402L18.1978 2.38527C18.101 2.28764 17.9858 2.21014 17.8589 2.15726C17.7319 2.10438 17.5958 2.07715 17.4583 2.07715C17.3207 2.07715 17.1846 2.10438 17.0577 2.15726C16.9307 2.21014 16.8155 2.28764 16.7187 2.38527L13.7812 5.33319L6.552 12.5519C6.45546 12.6493 6.37908 12.7647 6.32724 12.8916C6.2754 13.0185 6.24913 13.1544 6.24992 13.2915ZM17.4583 4.59361L20.4062 7.54152L18.927 9.02069L15.9791 6.07277L17.4583 4.59361ZM8.33325 13.7186L14.5103 7.54152L17.4583 10.4894L11.2812 16.6665H8.33325V13.7186Z"
                  fill="black"
                />
              </svg>

              <button
                type="button"
                class="close bg-white border-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="fs-30 fw-700">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body pt-0">
            <div class="row" v-if="!update.show">
              <div class="col-4 mb-2">
                <p class="fs-14 fw-700 txt-grey-900">Ngày tạo:</p>
              </div>
              <div class="col-8 mb-2">
                <p class="fs-14 txt-grey-900">
                  {{
                  viewingFileDetail &&
                  viewingFileDetail.date &&
                  moment(viewingFileDetail.date).format("DD/MM/YYYY")
                  }}
                </p>
              </div>
              <div class="col-4 mb-2">
                <p class="fs-14 fw-700 txt-grey-900">Bác sĩ PT:</p>
              </div>
              <div class="col-8 mb-2">
                <p class="fs-14 txt-grey-900">
                  {{
                  (viewingFileDetail &&
                  viewingFileDetail.surgical_main &&
                  viewingFileDetail.surgical_main.name) ||
                  (viewingFileDetail &&
                  viewingFileDetail.surgical_main_name) ||
                  ""
                  }}
                </p>
              </div>
              <div class="col-4">
                <p class="fs-14 fw-700 txt-grey-900">Bác sĩ gây mê:</p>
              </div>
              <div class="col-8">
                <p class="fs-14 txt-grey-900">
                  {{
                  (viewingFileDetail &&
                  viewingFileDetail.anaesthetic_main &&
                  viewingFileDetail.anaesthetic_main.name) ||
                  (viewingFileDetail &&
                  viewingFileDetail.anaesthetic_main_name) ||
                  ""
                  }}
                </p>
              </div>
            </div>

            <div v-else>
              <div class="mb-3 row">
                <div class="col-md-4">
                  <label class="mb-1 fs-16 txt-grey-900 fw-700 mt-2 required">Ngày tạo:</label>
                </div>
                <div class="col-md-8">
                  <input
                    v-model="update.form.date"
                    type="date"
                    class="form-control fw-700 txt-grey-900"
                  />
                </div>
              </div>
              <div class="mb-3 row">
                <div class="col-md-4">
                  <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Bác sĩ PT:</p>
                </div>
                <div class="col-md-8">
                  <el-select
                    @change="getDoctor(null)"
                    v-model="update.form.surgical_main"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Tìm kiếm tên bác sĩ"
                    class="w-100"
                    allow-create
                    :remote-method="getDoctor"
                    :loading="loadingDoctor"
                  >
                    <el-option
                      v-for="item in doctors"
                      :key="item.id + 'dtr'"
                      :label="item.name"
                      :value="item.user_id"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-md-4">
                  <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Bác sĩ gây mê:</p>
                </div>
                <div class="col-md-8">
                  <el-select
                    @change="getDoctor(null)"
                    v-model="update.form.anaesthetic_main"
                    filterable
                    remote
                    reserve-keyword
                    allow-create
                    placeholder="Tìm kiếm tên bác sĩ"
                    class="w-100"
                    :remote-method="getDoctor"
                    :loading="loadingDoctor"
                  >
                    <el-option
                      v-for="item in doctors"
                      :key="item.id + 'dtr'"
                      :label="item.name"
                      :value="item.user_id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="text-center" v-if="!update.show">
              <a
                href="javascript:;"
                class="txt-pri fs-14 text-decoration-underline"
                @click="
                  openFile(viewingFileDetail && viewingFileDetail.pdf_url)
                "
              >Xem phiếu</a>
            </div>
            <div class="flex mt-2" v-else>
              <div class="w-75">
                <p
                  class="fs-14 fw-700 txt-grey-900"
                  v-if="!update.form.pdf"
                >{{ appUtils.getFilename(viewingFileDetail.pdf_url) }}</p>
                <p
                  class="fs-14 fw-700 txt-grey-900"
                  v-else
                >{{ appUtils.getFilename(update.form.pdf.name) }}</p>
              </div>
              <div class="w-25 text-right">
                <a
                  href="javascript:;"
                  class="txt-grey-900 fs-14 text-decoration-underline"
                  @click="openSelectFile"
                >Thay đổi</a>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="update.show">
            <button type="button" class="btn btn-muted" @click="onCancelUpdate">Huỷ</button>
            <button
              :disabled="loading"
              type="button"
              class="btn bg-pri bd-pri text-white"
              @click="onSubmitUpdate"
            >
              <span
                class="spinner-border spinner-border-sm mr-1 fs-12"
                role="status"
                v-if="loading"
              ></span>
              <svg
                v-else
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M5.34961 3.61963H16.5696C17.067 3.61968 17.5465 3.80508 17.9146 4.13963L20.6946 6.66663C20.9009 6.85406 21.0657 7.08254 21.1785 7.33741C21.2913 7.59228 21.3496 7.86791 21.3496 8.14663V19.6196C21.3496 20.1501 21.1389 20.6588 20.7638 21.0338C20.3888 21.4089 19.88 21.6196 19.3496 21.6196H5.34961C4.81918 21.6196 4.31047 21.4089 3.9354 21.0338C3.56032 20.6588 3.34961 20.1501 3.34961 19.6196V5.61963C3.34961 5.0892 3.56032 4.58049 3.9354 4.20542C4.31047 3.83034 4.81918 3.61963 5.34961 3.61963V3.61963ZM5.34961 5.61963V19.6196H19.3496V8.14663L16.5696 5.61963H5.34961ZM9.34961 13.6196H15.3496C15.88 13.6196 16.3888 13.8303 16.7638 14.2054C17.1389 14.5805 17.3496 15.0892 17.3496 15.6196V19.6196C17.3496 20.1501 17.1389 20.6588 16.7638 21.0338C16.3888 21.4089 15.88 21.6196 15.3496 21.6196H9.34961C8.81918 21.6196 8.31047 21.4089 7.9354 21.0338C7.56032 20.6588 7.34961 20.1501 7.34961 19.6196V15.6196C7.34961 15.0892 7.56032 14.5805 7.9354 14.2054C8.31047 13.8303 8.81918 13.6196 9.34961 13.6196ZM9.34961 15.6196V19.6196H15.3496V15.6196H9.34961ZM16.3496 6.61963C16.6148 6.61963 16.8692 6.72499 17.0567 6.91252C17.2443 7.10006 17.3496 7.35441 17.3496 7.61963V10.6196C17.3496 10.8848 17.2443 11.1392 17.0567 11.3267C16.8692 11.5143 16.6148 11.6196 16.3496 11.6196C16.0844 11.6196 15.83 11.5143 15.6425 11.3267C15.455 11.1392 15.3496 10.8848 15.3496 10.6196V7.61963C15.3496 7.35441 15.455 7.10006 15.6425 6.91252C15.83 6.72499 16.0844 6.61963 16.3496 6.61963ZM8.34961 6.61963H13.3496C13.6148 6.61963 13.8692 6.72499 14.0567 6.91252C14.2443 7.10006 14.3496 7.35441 14.3496 7.61963V10.6196C14.3496 10.8848 14.2443 11.1392 14.0567 11.3267C13.8692 11.5143 13.6148 11.6196 13.3496 11.6196H8.34961C8.08439 11.6196 7.83004 11.5143 7.6425 11.3267C7.45497 11.1392 7.34961 10.8848 7.34961 10.6196V7.61963C7.34961 7.35441 7.45497 7.10006 7.6425 6.91252C7.83004 6.72499 8.08439 6.61963 8.34961 6.61963ZM9.34961 9.61963H12.3496V8.61963H9.34961V9.61963Z"
                  fill="white"
                />
              </svg>
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
    <input
      ref="selectFileUpdatePPTTT"
      class="d-none"
      name="file-upload"
      type="file"
      @change="onSelectFileUpdatePPTTT"
      accept="jpeg, .png, .jpg, .gif, .svg, .doc, .docx, .pdf, .xls, .xlsx, .xlsm, .ppt, .pptx, .heic"
      :key="fileInputKey"
    />

    <ModalSignPDF
      ref="ListReExamModalSignPDF"
      containerIDProps="ListReExamContainerSignPDFID"
      elementIDProps="ListReExamSignPDFID"
      imageIDProps="ListReExamSignPDFImageID"
      @onClose="getReExaminations"
    />
    <PdfViewer
      ref="ListReExamPdfViewer"
      containerIDProps="ContainerListReExamPDFViewerID"
      elementIDProps="ListReExamPDFViewerID"
      @onClose="getReExaminations"
    />
  </div>
</template>

  <script>
import _ from 'lodash'
import Detail from './Detail'
import ModalUploadFile from '../ModalUploadFile'
import modalCreateForm from './modalGiayHenKhamLai.vue'
import moment from 'moment'
import appUtils from '../../../utils/appUtils'
import { mapState } from 'vuex'
import { ENVELOPE_DOCUMENT_TYPE } from '../../../utils/constants'
import uploadS3File from '../../../utils/uploadS3File'
import SignatureRequest from '../../../api/request/SignatureRequest'
import PdfViewer from '../../PdfViewer/PdfViewer.vue'
import ModalSignPDF from '../../Signature/ModalSignPDF.vue'

export default {
  name: 'GiayHenKhamLaiList',
  components: {
    Detail,
    ModalUploadFile,
    modalCreateForm,
    ModalSignPDF,
    PdfViewer
  },
  data () {
    return {
      loading: false,
      loadingDoctor: false,
      showDetail: false,
      reExaminations: null,
      reExaminationsPaging: {},
      file: null,
      doctors: [],
      form: {
        surgical_main: null,
        medical_record_id: null,
        name: '',
        date: moment().format('YYYY-MM-DD HH:mm:ss')
      },
      moment,
      update: {
        form: {
          name: '',
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
          pdf_url: '',
          pdf: null,
          anaesthetic_main: '',
          surgical_main: ''
        },
        show: false
      },
      appUtils,
      viewingFileDetail: null,
      selectedFile: null,
      modalUpdateSaved: false,
      fileInputKey: 0
    }
  },
  watch: {
    '$route.query.vId' () {
      this.handleDetail()
    },
    showDetail (val) {
      if (!val) this.getReExaminations()
    }
  },
  mounted () {
    this.handleDetail()
    if (!this.showDetail) this.getReExaminations()
    let self = this
    this.$nextTick(function () {
      window.$('#modalPDF').on('hidden.bs.modal', function (e) {
        self.refresh()
      })
      window.$('#ModalChiTietPPTTT').on('hidden.bs.modal', function (e) {
        let query = Object.assign({}, self.$route.query)
        delete query.vId
        delete query.type
        self.$router.replace({ query }).catch(_ => {})
        self.getReExaminations()
        self.viewingFileDetail = null
        self.onCancelUpdate()
      })
      window.$('#ModalChiTietPPTTT').on('hide.bs.modal', function (e) {
        if (self.update.show && !self.modalUpdateSaved) {
          if (
            !confirm(
              'Các thay đổi có thể chưa được lưu. Bạn có muốn lưu không?'
            )
          ) {
            return true
          } else self.onSubmitUpdate()
        } else {
          self.modalUpdateSaved = false
        }
      })
    })
    this.getDoctor()
  },
  computed: {
    ...mapState({
      person: state => state.person
    })
  },
  methods: {
    getFilename (fullPath) {
      if (!_.isString(fullPath)) return
      return fullPath.split('/').pop()
    },
    getDoctor (search = null) {
      if (this.$globalClinic) {
        if (this.$globalClinic?.org_id) {
          this.getOrgDoctor(search)
        } else {
          this.getClinicDoctor(search)
        }
      }
    },
    async getOrgDoctor (search = null) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getOrgDoctor(this.$globalClinic?.org_id, params)
        .then(r => {
          this.doctors = r.data
          const hasMe = this.doctors.find(d => d.user_id === this.$user.id)
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = r.meta
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    async getClinicDoctor (search) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getClinicDoctor(this.$globalClinic?.id, params)
        .then(r => {
          this.doctors = r.data.data
          this.doctors.map(d => {
            d.name = d.doctor?.name
            d.user_id = d.doctor?.user_id
          })
          const hasMe = this.doctors.find(
            d => d.doctor_id === this.$user?.doctor.id
          )
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = {
            count: r.data.count,
            current_page: r.data.current_page,
            last_page: r.data.last_page,
            per_page: r.data.per_page,
            total: r.data.total
          }
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    refresh () {
      const fileInput = document.getElementById('file-upload')

      this.file = null
      fileInput.value = ''
      this.fileInputKey++

      this.form = {
        medical_record_id: null,
        name: '',
        date: moment().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    ModalCreate (show) {
      // this.$refs.modalCreateForm.openModal(show)
      window.$('#modalPhieuPhauThuat').modal(show ? 'show' : 'hide')
    },
    async createReExamination (event) {
      this.loading = true

      const params = {
        ...event,
        MedicalRecordId: this.$route.params.id,
        PersonId: this.person.id,
        WorkspaceId: this.$globalClinic.id,
        OrgId: this.$globalClinic.organization
          ? this.$globalClinic.organization.id
          : null
      }
      // console.log(params)
      const formData = new FormData()
      for (var key in params) {
        formData.append(key, params[key] || '')
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .postReExamination(formData)
        .then(r => {
          console.log(r)
          const dataId = r.data?.data.ID
          this.getReExaminations()
          console.log(dataId)
          this.$router.push({
            query: { tab: this.$route.query.tab, vId: dataId, type: 'view' }
          })
          this.$toast.open({
            message: 'Thêm thành công',
            type: 'success'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onSubmit () {
      if (!this.re_examination_time || !this.form.doctor_id) {
        return alert('Vui lòng chọn ngày giờ và bác sĩ')
      }
      const params = {
        ...this.form
      }
      const formData = new FormData()
      for (var key in params) {
        formData.append(key, params[key] || '')
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .postReExamination(this.$route.params.id, formData)
        .then(r => {
          this.getReExaminations()
          this.closeModal()
          window.$('button#closeModal').trigger('click')
          this.$toast
            .open({
              message: 'Upload file thành công',
              type: 'success'
            })
            .finally(() => {
              this.loading = false
            })
        })
    },
    showModal (show) {
      window.$('#modalPDF').modal(show ? 'show' : 'hide')
    },
    closeModal () {
      this.file = null
      this.form = {}
      this.refresh()
    },
    onSelectFile (event) {
      this.file = event.target.files[0]
    },
    onShowPickFile () {
      window.$('input[id="file-upload"]').trigger('click')
    },
    async handleDetail () {
      if (this.$route.query.vId) {
        // await this.showSurgery(this.$route.query.vId)
        // if (data?.pdf_url) {
        // this.onViewFile(data)
        // } else {
        this.showDetail = true
        // }
      } else {
        this.showDetail = false
      }
    },
    handleCurrentPage (page) {
      let query = Object.assign({}, this.$route.query)
      query.page = page
      this.$router.replace({ query }).catch(_ => {})
      this.getReExaminations()
    },
    async getReExaminations () {
      const id = this.$route.params.id
      this.loading = true
      const params = {
        limit: 50,
        MedicalRecordId: id,
        page: this.$route.query.page || 1,
        sort: 'created_at',
        sort_by: 'desc'
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .getReExaminations(params)
        .then(r => {
          console.log(r)
          this.reExaminations = r.data.data
          this.reExaminationsPaging = r.data.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    async goToViewDetail (row) {
      // this.$router.push({
      //   query: { tab: this.$route.query.tab, vId: item.ID, type: 'view' }
      // })
      this.loading = true

      const envelopeInfo = await this.openModalSignPDF(row)

      if (envelopeInfo) return

      this.$router
        .push({
          query: { tab: this.$route.query.tab, vId: row.ID, type: 'view' }
        })
        .catch(_ => {})
    },
    download (pdf) {
      window.open(pdf)
    },
    getDate (row) {
      if (row.examination_date) {
        return row.examination_date
          ? window.moment(row.examination_date).format('HH:mm DD/MM/YYYY')
          : ''
      } else {
        return ''
      }
    },
    getDateTime (row) {
      return row.re_examination_time
        ? window
          .moment(row.re_examination_time)
          .subtract(7, 'hours')
          .format('HH:mm DD/MM/YYYY')
        : ''
    },
    onUpdate () {
      let item = { ...this.viewingFileDetail }
      this.modalUpdateSaved = false
      this.update = {
        form: {
          id: item.id,
          name: item.name,
          date:
            (item.date && moment(item.date).format('YYYY-MM-DD')) ||
            moment().format('YYYY-MM-DD'),
          pdf_url: item.pdf_url,
          pdf: null,
          anaesthetic_main:
            item.anaesthetic_main_id || item.anaesthetic_main_name,
          surgical_main: item.surgical_main_id || item.surgical_main_name,
          medical_record_id: item.medical_record_id
        },
        show: true
      }
    },
    onShowModaViewFile (show) {
      window.$('#ModalChiTietPPTTT').modal(show ? 'show' : 'hide')
    },
    onViewFile (item) {
      if (!item) return
      this.viewingFileDetail = item
      this.onShowModaViewFile(true)
    },
    openFile (url) {
      if (!url) return
      window.open(url)
    },
    onCancelUpdate () {
      this.update = {
        id: null,
        form: {
          name: '',
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
          pdf_url: '',
          pdf: null,
          anaesthetic_main: '',
          surgical_main: ''
        },
        show: false,
        pdf: null
      }
      this.selectedFile = null
    },
    async onSubmitUpdate () {
      if (!this.update.form.id) return
      if (!this.update.form.date) {
        alert('Vui lòng nhập ngày')
        return
      }
      if (isNaN(this.update.form.anaesthetic_main)) {
        this.update.form.anaesthetic_main_name = this.update.form.anaesthetic_main
        this.update.form.anaesthetic_main_id = null
      } else {
        this.update.form.anaesthetic_main_id = this.update.form.anaesthetic_main
        this.update.form.anaesthetic_main_name = null
      }
      if (isNaN(this.update.form.surgical_main)) {
        this.update.form.surgical_main_name = this.update.form.surgical_main
        this.update.form.surgical_main_id = null
      } else {
        this.update.form.surgical_main_id = this.update.form.surgical_main
        this.update.form.surgical_main_name = null
      }
      const formData = new FormData()
      const data = (({
        name,
        date,
        pdf,
        anaesthetic_main_name,
        anaesthetic_main_id,
        surgical_main_name,
        surgical_main_id,
        medical_record_id,
        pdf_url
      }) => ({
        name,
        date,
        pdf,
        anaesthetic_main_name,
        anaesthetic_main_id,
        surgical_main_name,
        surgical_main_id,
        medical_record_id,
        pdf_url
      }))(this.update.form)
      for (const key in data) {
        if (data[key]) formData.append(key, data[key])
      }
      this.modalUpdateSaved = true
      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .updateSurgery(this.update.form.id, formData)
        .then(r => {
          this.$toast.open({
            message: 'Cập nhật thành công',
            type: 'success'
          })
          this.viewingFileDetail = {
            user: this.viewingFileDetail?.user,
            ...r.data
          }
          this.onCancelUpdate()
          this.getReExaminations()
        })
        .finally(() => {
          this.loading = false
        })
    },
    openSelectFile () {
      this.$refs.selectFileUpdatePPTTT.click()
      this.$refs.selectFileUpdatePPTTT.value = null
    },
    onSelectFileUpdatePPTTT (event) {
      this.selectedFile = event.target.files[0]
      this.update.form.pdf = event.target.files[0]
      this.$refs.selectFileUpdatePPTTT.value = null
    },
    async showSurgery (id) {
      this.loading = true
      const resp = await this.$rf
        .getRequest('DoctorRequest')
        .showSurgery(id)
        .then(r => {
          return r.data
        })
        .finally(() => {
          this.loading = false
        })
      return resp
    },
    async openModalSignPDF (item) {
      const envelopeInfo = await this.handleCheckSignEnvelope(item)

      return envelopeInfo
    },
    async handleCheckSignEnvelope (item) {
      try {
        const documentID = item?.ID
        const signEnvelope = await this.getSignEnvelopeByDocID(item)
        if (!signEnvelope) return

        const signatories = signEnvelope?.envelope_signatories?.map(item => ({
          ...item,
          user: item?.user_info,
          user_id: item?.user_id
        }))

        const signerInfo = signEnvelope?.envelope_signatories?.find(
          item => item?.user_id === this.$user?.id
        )

        const s3Url = await uploadS3File.getLinkVideoAWS(
          signEnvelope?.document_url
        )

        if (signerInfo?.status === 2) {
          this.$nextTick(() => {
            this.$refs.ListReExamPdfViewer.handleOpen(
              s3Url,
              ENVELOPE_DOCUMENT_TYPE.RE_EXAM_FORM,
              documentID,
              false,
              false
            )
          })
        } else {
          const hasPermissionSignatory = signatories?.some(
            item => item?.user_id === this.$user?.id
          )

          if (!hasPermissionSignatory) {
            this.$toast.open({
              message: 'Bạn không có quyền ký tài liệu này',
              type: 'error'
            })
            return
          }
          this.$nextTick(() => {
            this.$refs.ListReExamModalSignPDF.handleOpen(
              s3Url,
              ENVELOPE_DOCUMENT_TYPE.RE_EXAM_FORM,
              documentID,
              signerInfo?.user_id,
              signatories || [],
              signEnvelope
            )
          })
        }

        return signEnvelope
      } catch (error) {
        console.log(error)
      }
    },
    async getSignEnvelopeByDocID (item) {
      try {
        const request = new SignatureRequest()
        const response = await request.getSignEnvelopeByDocumentID({
          doc_id: item?.ID,
          doc_type: ENVELOPE_DOCUMENT_TYPE.RE_EXAM_FORM
        })

        return response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
::v-deep {
  .modal {
    z-index: 2001 !important;
  }
  .handleLoading {
    z-index: 0;
  }
}
</style>
